import { render, staticRenderFns } from "./AgendaCalendarView.vue?vue&type=template&id=ab22cbe0&scoped=true&"
import script from "./AgendaCalendarView.vue?vue&type=script&lang=ts&"
export * from "./AgendaCalendarView.vue?vue&type=script&lang=ts&"
import style0 from "./AgendaCalendarView.vue?vue&type=style&index=0&id=ab22cbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab22cbe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
